<template>
  <!-- numeração -->
  <div class="md:col-span-2">
    <BaseInput
      type="text"
      name="itensForm.value.numeracao"
      v-model="store.itensForm.values.numeracao"
      :info="'Numeração e etiqueta'"
      label="Numeração e etiqueta"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.numeracao = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- qtd mangueiras -->
  <div class="md:col-span-1">
    <BaseInput
      type="number"
      :min="1"
      name="itensForm.values.qtd_mangueira"
      v-model="store.itensForm.values.qtd_mangueira"
      :info="'Qtd. Mangueiras'"
      label="Qtd. Mangueiras"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.qtd_mangueira = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado da caixa -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado da caixa
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.estado_caixa"
          :initialValue="store.itensForm.values.estado_caixa"
          @selected-data="(val) => (store.itensForm.values.estado_caixa = val)"
        />
      </div>
    </div>
  </div>

  <!-- mangueiras obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.estado_caixa?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.estado_caixa_descript"
        :info="'Descrição da caixa'"
        label="Pintura irregular, amassada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.estado_caixa_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- lacre externo -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Lacre externo
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.estado_caixa"
          :initialValue="store.itensForm.values.lacre_ext"
          @selected-data="(val) => (store.itensForm.values.lacre_ext = val)"
        />
      </div>
    </div>
  </div>

  <!-- lacre externo -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.lacre_ext?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.lacre_ext_descript"
        :info="'Condição do lacre'"
        label="Sem lacre, rompido..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.lacre_ext_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- estado das mangueiras -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Condição das mangueiras
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.estado_caixa"
          :initialValue="store.itensForm.values.estado_mangueiras"
          @selected-data="(val) => (store.itensForm.values.estado_mangueiras = val)"
        />
      </div>
    </div>
  </div>

  <!-- mangueiras obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.estado_mangueiras?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.estado_mangueiras_descript"
        :info="'Inadequação das mangueiras'"
        label="Furadas, não usuais..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.estado_mangueiras_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- esguicho -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Esguicho
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.bicos_e_keys"
          :initialValue="store.itensForm.values.esguicho"
          @selected-data="(val) => (store.itensForm.values.esguicho = val)"
        />
      </div>
    </div>
  </div>

  <!-- esguicho obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.esguicho?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.esguicho_descript"
        :info="'Inadequação do esguicho'"
        label="Danificado, não contém..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.esguicho_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- chave storz -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Chaves storz
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.bicos_e_keys"
          :initialValue="store.itensForm.values.storz_keys"
          @selected-data="(val) => (store.itensForm.values.storz_keys = val)"
        />
      </div>
    </div>
  </div>

  <!-- chave storz obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.storz_keys?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.storz_keys_descript"
        :info="'Inadequação da chave storz'"
        label="Não presente, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.storz_keys_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- condição conexões -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Condição das conexões
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.bicos_e_keys"
          :initialValue="store.itensForm.values.conexoes"
          @selected-data="(val) => (store.itensForm.values.conexoes = val)"
        />
      </div>
    </div>
  </div>

  <!-- conexão descript -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.conexoes?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.conexoes_descript"
        v-model="store.itensForm.values.conexoes_descript"
        :info="'Condição'"
        label="Ruim, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.conexoes_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- sinalização -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Sinalização
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.sinalizacao"
          @selected-data="(val) => (store.itensForm.values.sinalizacao = val)"
        />
      </div>
    </div>
  </div>

  <!-- sinalização obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.sinalizacao?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.sinalizacao_descript"
        :info="'Sinalização inadequada'"
        label="Gasta, irregular..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.sinalizacao_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- valvula globo -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Válvula globo
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.valv_globo"
          @selected-data="(val) => (store.itensForm.values.valv_globo = val)"
        />
      </div>
    </div>
  </div>

  <!-- valvula globo obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.valv_globo?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.valv_globo_descript"
        :info="'Inadequada da válvula'"
        label="Danificada, irregular..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.valv_globo_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- registro -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Registro
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.registro"
          @selected-data="(val) => (store.itensForm.values.registro = val)"
        />
      </div>
    </div>
  </div>

  <!-- registro obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.registro?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.registro_descript"
        :info="'Inadequação do registro'"
        label="Danificado, quebrado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.registro_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- visor -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Visor
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.visor"
          @selected-data="(val) => (store.itensForm.values.visor = val)"
        />
      </div>
    </div>
  </div>

  <!-- vidor obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.visor?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.visor_descript"
        :info="'Inadequação do visor'"
        label="Sem visor, trincado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.visor_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- tampão da válvula globo -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Tampão da válvula globo
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.tampao"
          @selected-data="(val) => (store.itensForm.values.tampao = val)"
        />
      </div>
    </div>
  </div>

  <!-- tampão da válvula globo obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.tampao?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.tampao_descript"
        :info="'Condição da válvula'"
        label="Não contém, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.tampao_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- cond. hidrante -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Condição do hidrante
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="hydrant.sinalizacao"
          :initialValue="store.itensForm.values.cond_hidrante"
          @selected-data="(val) => (store.itensForm.values.cond_hidrante = val)"
        />
      </div>
    </div>
  </div>

  <!-- tampão da válvula globo obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.cond_hidrante?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.cond_hidrante_descript"
        :info="'Condição do hidrante'"
        label="Danificado, irregular..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.cond_hidrante_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- vencimento do TH -->
  <div class="md:col-span-2">
    <BaseInput
      type="date"
      name="itensForm.next_check"
      v-model="store.itensForm.th_expiration"
      :info="'Vencimento do TH.'"
      label="Vencimento do teste hidrostático"
      :required-field="false"
      :activeDefault="true"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.th_expiration = null"
        />
      </template>
    </BaseInput>
  </div>

</template>

<script setup>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { dataExtinguisher } from '../../store'
import { hydrant } from '../../lookups/form'

const store = dataExtinguisher.state

</script>
